module.exports = __webpack_public_path__ + "img/football.18cd3fb7.svg";